import { SettingLineLight, SlantPilotCustom } from '@repo/go-icons';
import { ActionsBar } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { DoubleTooltipSidebarItem } from '../../shared/components/DoubleTooltipSidebarItem/DoubleTooltipSidebarItem';
import { SelectableWellboreList } from '../../shared/components/SelectableWellboreList/SelectableWellboreList';
import type { DirectionalDrillingState } from '../store/DirectionalDrillingState';

import { ParametersSettings } from './ParametersSettingsPanel';

export const DirDrillingActionsBar = observer(function DirDrillingActionsBar({
  widgetState,
}: {
  widgetState: DirectionalDrillingState;
}) {
  const { t } = useTranslation('directionalDrillingWidget');

  return (
    <ActionsBar>
      <ActionsBar.TopBar>
        <DoubleTooltipSidebarItem
          outerTitle={t('wellboreSelection')}
          disabled={widgetState.isLoading}
          innerTitle={() => (
            <SelectableWellboreList
              wellbores={widgetState.wellbores.list}
              activeTitle={t('activeWellbore')}
              onChange={(id) => void widgetState.switchWellbore(id)}
              value={widgetState.wellbores.selected?.id}
            />
          )}
          icon={<SlantPilotCustom />}
        />
      </ActionsBar.TopBar>
      <DoubleTooltipSidebarItem
        outerTitle={t('settings')}
        disabled={!widgetState.fullyLoaded || !!widgetState.baseParamsIssue || !!widgetState.error}
        innerTitle={(close) => <ParametersSettings close={close} widgetState={widgetState} />}
        icon={<SettingLineLight />}
      />
    </ActionsBar>
  );
});
